import HomeDrawCreditFormOffRamp from "../forms/HomeDrawCreditFormOffRamp";
import {AvailableBalance} from "../../utils/creditService";

interface HomeDrawCreditModalViewOffRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance
}

function HomeDrawCreditModalViewOffRamp(
  {
    onCloseModal,
    handleBack,
    creditLine,
  }:HomeDrawCreditModalViewOffRampProps) {
  return (

    <HomeDrawCreditFormOffRamp
      onCloseModal={onCloseModal}
      handleBack={handleBack}
      creditLine={creditLine}
    />

  );
}

export default HomeDrawCreditModalViewOffRamp;